import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import get from 'lodash/get';

import objectIsSafe, {
  fragments as filterFragments
} from '../../../lib/filters';

export const recentlyViewedQuery = (customFragments = []) => {
  const allFragments = [...filterFragments, ...customFragments];

  return gql`
    query GetRecentlyViewed($locale: String!, $country: String!, $currency: String!) {
      recentlyViewed(limit: 24) {
        viewedItems(locale: $locale, country: $country, currency: $currency, previewTypeIds: ["product_close"]) {
          __typename
          ${allFragments.map(({ name }) => `...${name}`).join('\n')}
        }
      }
    }
    ${allFragments.reduce(
      (acc, { fragment }) => gql`
        ${acc}
        ${fragment}
      `,
      ''
    )}
  `;
};

export const useRecentlyViewed = ({ country, currency, locale, fragments }) => {
  const { data, loading, error } = useQuery(recentlyViewedQuery(fragments), {
    variables: { country, currency, locale },
    skip: !(country, currency, locale),
    ssr: true
  });

  const items = get(data, 'recentlyViewed.viewedItems', []).filter(
    objectIsSafe
  );

  return { items, loading, error };
};

export default useRecentlyViewed;
